import { render, staticRenderFns } from "./BaseCardSimple.vue?vue&type=template&id=33faa97a"
import script from "./BaseCardSimple.vue?vue&type=script&lang=js"
export * from "./BaseCardSimple.vue?vue&type=script&lang=js"
import style0 from "./BaseCardSimple.vue?vue&type=style&index=0&id=33faa97a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports